const dataPlanExtension = {
  dataPlanExtension: {
    heading: "Mobiele Connectie Gegevensuitbreiding",
    cellModemIMEI: "IMEI-Nummer des Mobilfunkmodems",
    siteName: "Naam systeem",
    siteAddress: "Systeemadres",
    cellPlanEndDate: "Einddatum van het celmodemplan",
    daysToExpiry: "Dagen tot vervaldag",
    currentPlanStatus: "Huidig plan toestand",
    gatewaySNo: "Gateway S.NO",
    paymentStatus: "Betalingsstatus",
    lastDateOfPurchase: "Laatste aankoopdatum",
    extendDataPlan: "Verleng het data-abonnement",
    purchasedBy: "Gekocht door",
    purchasedFrom: "Gekocht van",
    siteId: "Systeem-ID",
    orderNo: "Bestellnummer",
    footer: 'Mobiele Connectie Gegevensuitbreiding',
    total: 'Totaal',
    record: 'verslagen',
    records: 'verslagen',
    show: 'wijzen',
    enphase_store: 'Enphase Store',
    orderSummary: 'overzicht van de bestelling.',
    confirmSelection: 'Bevestig hieronder uw keuze',
    noOfCellModems: 'Aantal mobiele modems',
    years: 'jaren',
    pricePerSite: 'Prijs per locatie',
    cancel:'Annuleren',
    submit:'Indienen',
    back: 'Rug',
    noTokens: '** Geen mobiele modems beschikbaar **',
    redirectToStoreText: 'Omleiden naar Enphase Store! Even geduld aub...!',
    toolTipExtensionInfo: 'Alleen mobiele modemabonnementen met een vervaldatum van minder dan 180 dagen komen in aanmerking voor verlenging.',
    allCellModems: 'Alle mobiele modems',
    dataplanTitleTooltip: 'This is an extension to Enphase monitoring, software/firmware upgrades, and other remote services offered via your existing AT&T cell modem. This extension will enable you to continue using the same physical hardware, beyond its 5-year term you had originally purchased, by renewing its connectivity instead of having to purchase a new physical device.',
    eligibleCellModems: 'In aanmerking komende mobiele modems',
    nonAdminInfo: 'Neem contact op met de beheerder om het data-abonnement voor een mobiele modem te verlengen',
    select: 'Wählen',
    typeToSearch: 'Tippe um zu suchen',
    dataPlanExtensionSuccess: "De mobiele connectie gegevensuitbreiding is gelukt. Het kan even duren voordat de betaling zichtbaar is in het dashboard",
    expired: 'Verlopen',
    active: 'Actief',
    failed: "Betaling mislukt",
    pending: "Betalingsverwerking",
    success: "Betaling gelukt",
  }
}

export default dataPlanExtension